// Common
import { Inject, Injector, Optional, Pipe, untracked, type PipeTransform, type Signal } from '@angular/core';
import { listWorkspaceScope } from '@modules/common/components/item-workspace/list-workspace-scope';
import { checkExhaustiveness } from '@modules/common/utils/switch';

// Types
import { VirtualFolder } from '@modules/messages/types/virtual-folder';

@Pipe({
  name: 'titleByMessagesFilter',
  standalone: false,
  pure: false,
})
export class TitleByMessagesFilterPipe implements PipeTransform {
  private workspaceScope?: Signal<'team' | 'mine' | undefined>;

  public constructor(@Optional() @Inject(Injector) private readonly injector: Injector | null = null) {}

  public transform(value: VirtualFolder, containerName?: string | null, nameWorkspace = false): string {
    const injector = this.injector;
    if (nameWorkspace && value === 'inbox' && injector) {
      this.workspaceScope ??= untracked(() => listWorkspaceScope(injector));
      const workspace = this.workspaceScope();
      if (workspace) return `${workspace === 'team' ? 'Team' : 'My'} Inbox`;
    }
    if (!value) {
      return containerName || 'All';
    }

    switch (value) {
      case 'assigned_to_me':
        return 'Assigned to me';
      case 'following':
        return 'Following';
      case 'inbox':
        return 'Inbox';
      case 'vip':
        return 'VIP';
      case 'bulk':
        return 'Bulk';
      case 'other_mail':
        return 'Other Mail';
      case 'sent':
        return 'Sent';
      case 'draft':
        return 'Drafts';
      case 'flagged':
        return 'Flagged';
      case 'archived':
        return 'Archive';
      case 'deleted':
        return 'Trash';
      case 'spam':
        return 'Spam';
      case 'all_folders':
        return 'Folders';
      case 'followed':
        return 'Follow Up';
      case 'snoozed':
        return 'Snoozed';
      case 'scheduled':
        return 'Scheduled';
      case 'search_results':
        return 'All Results';
      default:
        return checkExhaustiveness(value);
    }
  }
}
